import React from 'react'

const NewEmployeeList = () => {
  return (
    <div>
      
    </div>
  )
}

export default NewEmployeeList
